module.exports = __webpack_public_path__ + "img/m_ic_close.307a4c06.svg";